// extracted by mini-css-extract-plugin
export default {"footerPanel":"_1ahUgxEcGwkjx62rmnTZ1c"};